// eslint-disable-next-line import/no-cycle
import { Platform } from "../../types";

/* eslint-disable no-unused-vars */
import { DocumentType, StatementStatus, Province, TenderType, TenderStatus } from "../../types/Enums";

export type Address = {
  street1: string;
  street2: string;
  suburb: string;
  city: string;
  province: Province;
  code: string;
};

export type BillingAddress = {
  country?: string;
  complexBuilding?: string;
  streetAddress?: string;
  suburb?: string;
  city?: string;
  province?: string;
  postalCode?: string;
};

export type Customer = {
  customerName: string;
  emailAddress: string;
  contactNumber?: string;
  billingAddress: BillingAddress;
};

export type Product = {
  catalogueItemId: string;
  category: string;
  name: string;
  description: string;
  quantity: number;
  price: number;
  vat: boolean;
  variant?: ProductVariant;
  duration?: number;
};

export type ProductVariant = {
  catalogueItemID: string;
  variantID: string;
  variantValues: {
    [key: string]: string;
  };
};

export type Tender = {
  tenderType: TenderType;
  status: TenderStatus;
  reference: string;
  price: number;
};

export type BaseStatement = {
  id: string;
  createDate: string;
  lastModifiedDate: string;
  customer: Customer;
  documentType: DocumentType;
  dueDate: string;
  invoiceReference?: string;
  tenderList: Tender[];
  paymentReference?: string;
  productList: Product[];
  status: StatementStatus;
  additionalNotes?: string;
  platform: Platform;
  ownerId: string;
  businessLogo?: {
    original: string;
    cropped: string;
    small: string;
    medium: string;
    large: string;
  };
};

export type OwnerInfo = {
  companyName: string;
  address: Address;
  phoneNumber: string;
  email: string;
  vatNumber?: string;
  companyRegistrationNumber?: string;
};

export enum ResponseCode {
  IK_01 = "IK01",
  IK_02 = "IK02", // Last owner statement not found
  IK_03 = "IK03", // Statement type not found
  IK_04 = "IK04", // No owner statements found
  IK_05 = "IK05", // No owner company name found
  IK_06 = "IK06", // Failed to create owner statement
  IK_07 = "IK07", // Error creating owner statement
  IK_08 = "IK08", // No owner statement found
  IK_09 = "IK09", // No owner info found
  IK_10 = "IK10", // Error sending email
  IK_11 = "IK11", // No customer statement found
}

export type StatementPaylinkHTTPSuccessResponse = {
  code: ResponseCode;
  tender: Tender;
};

export type StatementResponse = {
  code: ResponseCode;
  statement: BaseStatement;
  owner: OwnerInfo;
};

export type HttpSuccessResponse = {
  statementResponse: StatementResponse;
  success: true;
};

export type LastEvaluatedKey = {
  sk: string;
};

export type StatementHTTPResponse = {
  code: string;
  lastEvaluatedKey: LastEvaluatedKey;
  statements: BaseStatement[];
};

export type Merchant = {
  companyName: string;
  email: string;
  phoneNumber: string;
  address: Address;
  ecommLimitOverride: number;
};

export type MerchantHttpSuccessResponse = {
  code: ResponseCode;
  ownerInfo: Merchant;
};

export type InvoiceUpdateHttpSuccessResponse = {
  code: ResponseCode;
};

export type StockAvailabilityItem = {
  productId: string;
  currentValue: number;
};

export type GetStockAvailabilityResponse = {
  responseCode?: string;
  responseMessage?: string;
  products?: string[];
  unavailable?: StockAvailabilityItem[];
};
